import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
  styles: ':host { display: block; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    // NEO typography and grid styles are scoped under `.neo-ds`; brand tokens under `.BMW`.
    class: 'neo-ds BMW',
  },
})
export class App {}
